import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  inject,
} from '@angular/core';
import { AnnuityDialogComponent } from '../annuity-dialog/annuity-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-annuity-lookup',
  templateUrl: './annuity-lookup.component.html',
  styleUrls: ['./annuity-lookup.component.scss'],
  imports: [MatIconModule, CommonModule, MatButtonModule],
})
export class AnnuityLookupComponent implements OnInit {
  private dialog = inject(MatDialog);
  private params = inject(ActivatedRoute);

  @Output() beaconData = new EventEmitter();
  @Input() index;
  @Input() fieldData;

  dialogRef;
  profile;
  varset;
  buttonColor;
  buttonLabel: string;

  ngOnInit() {
    this.buttonLabel =
      this.fieldData.props?.options?.find(opt => opt.value === '2')?.label ||
      'Look up Annuity Data';
    this.params.params.subscribe(params => {
      this.profile = params.id;
    });
    this.buttonColor =
      this.fieldData.type === 'custom-manual-lookup-document'
        ? 'primary'
        : 'accent';
  }

  triggerLookUp(data) {
    if (this.fieldData.type === 'custom-manual-lookup-document') {
      this.fieldData.formControl.setValue(2);
    }

    this.varset = this.fieldData.key.split('_')[0];

    if (!this.dialogRef) {
      const model = this.fieldData.parent.parent.parent.model;
      this.dialogRef = this.dialog.open(AnnuityDialogComponent, {
        panelClass: 'beacon-dialog',
        autoFocus: false,
        data: {
          companies: data,
          index: this.index,
          group: this.fieldData.templateOptions.group,
          profile: this.profile,
          varset: this.varset,
          showFixedRate:
            model.UnitExchange_ShowCurrentFixedRate.toLowerCase() === 'y' &&
            model.UnitExchange_ShowMinimumFixedRate.toLowerCase() === 'y',
        },
        minHeight: '50vh',
        width: '70vw',
      });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }

  alphabetize(a, b) {
    const nameA = a.name.toUpperCase(); // ignore upper and lowercase
    const nameB = b.name.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  }
}
